import _ from 'underscore';
import Backbone from 'backbone';
import inlineErrorTemplate from '@bingads-webui-campaign-legacy/editorial-appeal/template/inline-error.pug';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/editorial-appeal');

export default class InlineErrorView extends Backbone.View {
  get events() {
    return {
      '.button': this.onCancel,
    };
  }

  initialize({
    rowId,
    callback = _.noop,
    useKwCss = false,
  }) {
    this.rowId = rowId;
    this.callback = callback;
    this.useKwCss = useKwCss;
  }

  render() {
    this.$el.html(inlineErrorTemplate({ rowId: this.rowId, useKwCss: this.useKwCss, i18n }));

    return this;
  }

  onCancel() {
    this.callback(this.rowId);
  }

  removeCancel() {
    this.$('.button').remove();
  }
}
